import { render } from "./ProjectForm.vue?vue&type=template&id=7d7ad155&scoped=true&ts=true"
import script from "./ProjectForm.vue?vue&type=script&lang=ts"
export * from "./ProjectForm.vue?vue&type=script&lang=ts"

import "./ProjectForm.vue?vue&type=style&index=0&id=7d7ad155&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7ad155"]])

export default __exports__